import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { SEO_NAVIGATION_ITEMS } from '../../Navigation';
import { ContentSection, MainContent } from '../MainContent';

import type { Props } from '../PageLayout/PageLayout';

import STYLES from './SEOPageLayout.module.scss';

const cls = cssModules(STYLES);
const SEOPageLayout = ({ components }: Props) => {
  const {
    amenities,
    confidenceMessaging,
    contentBlurb,
    crossLinks,
    faqs,
    fastFacts,
    goodToKnow,
    hotelDescription,
    hotelInformation,
    hotelMedia,
    hotelPrices,
    location,
    navigation,
    reviews,
  } = Object.keys(components)
    .map((key) => {
      const item = SEO_NAVIGATION_ITEMS.find(({ id }) => id === key);
      const content = components[key] ? (
        <ContentSection
          key={key}
          id={item?.anchorName}
          className={cls(`SEOPageLayout__${key}`)}
        >
          {components[key]}
        </ContentSection>
      ) : null;
      return { [key]: content };
    })
    .reduce((result, currentValue) => Object.assign(result, currentValue), {});

  return (
    <>
      {components.breadcrumbsSectionTop}
      {hotelInformation}
      {hotelMedia}
      <MainContent>
        {navigation}
        {confidenceMessaging}
        {hotelPrices}
        {fastFacts}
        {amenities}
        {hotelDescription}
        {contentBlurb}
        {reviews}
        {location}
        {goodToKnow}
        {faqs}
        {crossLinks}
      </MainContent>
      <div className={cls('SEOPageLayout__bottomSection')}>
        <MainContent>
          {components.exploreOtherOptions}
          {components.internalLinks}
          {components.breadcrumbsSectionBottom}
        </MainContent>
      </div>
      {components.scrollTopButton}
    </>
  );
};

export default SEOPageLayout;
